import {
  Box,
  Button,
  Card,
  Container,
  Grid,
  Stack,
  TextField,
  Typography,
  Paper,
  useTheme,
  useMediaQuery
} from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import chaletApi from '../../../api/chaletApi';
import { toast } from 'react-hot-toast';
import { ChaletLogo } from 'ui/components/common';

export const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [login, result] = chaletApi.useLazyLoginQuery();

  useEffect(() => {
    if (result.isError) {
      toast('Error iniciando sesión');
    }
  }, [result]);

  const handleSubmit = useCallback(
    (e: any) => {
      e.preventDefault();
      login({ email, password });
    },
    [email, password, login]
  );
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <Box
      sx={{
        minHeight: '100vh',
        background: 'linear-gradient(135deg, #EF3D32 0%, #ffaf45 200%)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        p: 2
      }}>
      <Container maxWidth="sm">
        <Paper
          elevation={24}
          sx={{
            p: isMobile ? 3 : 5,
            borderRadius: 3,
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(10px)',
            border: '1px solid rgba(255, 255, 255, 0.2)'
          }}>
          <form onSubmit={handleSubmit}>
            <Stack spacing={3} alignItems="center">
              <Box sx={{ mb: 2 }}>
                <ChaletLogo width={80} height={80} />
              </Box>

              <Stack spacing={1} textAlign="center">
                <Typography variant={isMobile ? 'h4' : 'h3'} fontWeight={700} color="primary.main">
                  El Chalet
                </Typography>
                <Typography
                  variant={isMobile ? 'body1' : 'h6'}
                  fontWeight={500}
                  color="text.secondary">
                  Panel administrativo de comercio
                </Typography>
              </Stack>

              <Stack spacing={2.5} width="100%">
                <TextField
                  label="Email"
                  type="email"
                  variant="outlined"
                  fullWidth
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2
                    }
                  }}
                />
                <TextField
                  label="Contraseña"
                  type="password"
                  variant="outlined"
                  fullWidth
                  required
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  sx={{
                    '& .MuiOutlinedInput-root': {
                      borderRadius: 2
                    }
                  }}
                />

                <Button
                  variant="contained"
                  type="submit"
                  size="large"
                  fullWidth
                  disabled={result.isLoading}
                  sx={{
                    mt: 2,
                    py: 1.5,
                    borderRadius: 2,
                    fontSize: '1.1rem',
                    fontWeight: 600,
                    textTransform: 'none',
                    background: 'linear-gradient(45deg, #EF3D32 30%, #ff6b60 90%)',
                    boxShadow: '0 3px 5px 2px rgba(239, 61, 50, .3)',
                    '&:hover': {
                      background: 'linear-gradient(45deg, #d63429 30%, #ef4d42 90%)',
                      boxShadow: '0 6px 10px 2px rgba(239, 61, 50, .3)'
                    }
                  }}>
                  {result.isLoading ? 'Iniciando sesión...' : 'Iniciar Sesión'}
                </Button>
              </Stack>
            </Stack>
          </form>
        </Paper>
      </Container>
    </Box>
  );
};
